import { HostListener, Directive, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

@Directive({
  selector: '[appNumericOnly]',
})
export class NumericOnlyDirective {
  private control = inject(NgControl);

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (!this.isNumberKey(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(e: ClipboardEvent) {
    if (!this.control.control || !e.clipboardData) {
      return;
    }

    this.control.control.setValue(this.sanitizeData(e.clipboardData.getData('text')));
    e.preventDefault();
  }

  private isNumberKey(char: string) {
    return numbers.includes(char);
  }

  private sanitizeData(data: string): string {
    const result: string[] = [];

    for (const char of data) {
      if (this.isNumberKey(char)) {
        result.push(char);
      }
    }

    return result.slice(0, 9).join('');
  }
}
